import React from 'react';
import { Box, BoxProps, Theme, withStyles } from '@material-ui/core';
import FsBodySmallBold from 'ui-elements/typography/FsBodySmallBold';
import FsBodySmall from 'ui-elements/typography/FsBodySmall';
import FsBodyMediumBold from 'ui-elements/typography/FsBodyMediumBold';

export const ContainerBox = withStyles(
  ({ breakpoints, spacing, palette }: Theme) => ({
    root: {
      width: '100%',
      boxSizing: 'border-box',
      padding: spacing(3.5),
      backgroundColor: palette.grey[100],
      borderRadius: 10,
      marginTop: spacing(2),
      position: 'relative',
      [breakpoints.up('sm')]: {
        marginTop: spacing(3),
      },
      [breakpoints.up('md')]: {
        width: '50%',
        marginTop: 0,
        borderRadius: 0,
        borderTopRightRadius: 10,
        borderBottomRightRadius: 10,
      },
    },
  })
)((props: BoxProps & { ref?: React.Ref<unknown> }) => <Box {...props} />);

export const HeaderBox = withStyles(({ spacing }) => ({
  root: {
    paddingTop: spacing(1),
    marginBottom: spacing(4),
  },
}))((props: BoxProps) => <Box display="flex" {...props} />);

export const BodyRelativeBox = withStyles(() => ({
  root: {
    position: 'relative',
  },
}))((props: BoxProps) => <Box {...props} />);

export const AbsoluteBox = withStyles(({ breakpoints, spacing }: Theme) => ({
  root: {
    width: `100%`,
    position: 'static',
    boxSizing: 'border-box',
    height: 600,
    [breakpoints.up('md')]: {
      padding: spacing(0, 3.5),
      position: 'absolute',
      top: '80px',
      left: 0,
      height: `calc(100% - 120px)`,
    },
  },
}))(Box);

export const AbsoluteNoEventsFeedBox = withStyles(({ breakpoints }: Theme) => ({
  root: {
    width: `100%`,
    position: 'static',
    boxSizing: 'border-box',
    [breakpoints.up('md')]: {
      position: 'absolute',
      top: 0,
      left: 0,
      bottom: 0,
      right: 0,
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
    },
  },
}))(Box);

export const Title = withStyles({})((props) => (
  <FsBodySmallBold component="h3" {...props} />
));

export const TitleCount = withStyles(({ palette, spacing }: Theme) => ({
  root: {
    color: palette.grey[400],
    marginLeft: spacing(1),
  },
}))((props) => <FsBodySmall component="h3" {...props} />);

export const NoEventsFeedTitle = withStyles(({ spacing }: Theme) => ({
  root: {
    textAlign: 'center',
    marginTop: spacing(1),
  },
}))(FsBodyMediumBold);

export const NoEventsFeedSubTitle = withStyles(({ palette }: Theme) => ({
  root: {
    textAlign: 'center',
    color: palette.grey[400],
  },
}))(FsBodySmallBold);

export const CenterBox = withStyles(() => ({
  root: {
    display: 'flex',
    justifyContent: 'center',
  },
}))(Box);
